import { ReflectionMapDto } from '../dto/reflection-map.dto'
import { WidgetConfigDto } from '../dto/widget-config.dto'
import { BaseConfig } from './base-config.object'

export class WidgetConfig extends BaseConfig {
  readonly widgetReflectionMap?: ReflectionMapDto
  readonly carat?: string
  readonly ringPositionHeight?: number
  readonly revertDirection?: boolean

  constructor(widgetConfigDto: WidgetConfigDto) {
    super(widgetConfigDto)
    this.widgetReflectionMap = widgetConfigDto.widgetReflectionMap
    this.carat = widgetConfigDto.carat
    this.ringPositionHeight = widgetConfigDto.ringPositionHeight
    this.revertDirection = widgetConfigDto.revertDirection
  }
}
